import {
    collection,
    addDoc,
    getDocs,
    updateDoc,
    doc,
    query,
    where,
    arrayUnion,
    arrayRemove,
    setDoc,
    getDoc,
    Timestamp,
    deleteDoc
} from "firebase/firestore";
import {
    generateClassroomId,
} from "../utils/commonUtils";
import { db } from "./firebase";



export const mergeManualWithRealStudent = async (dummyId, realId) => {
    const dummySnap = await getDoc(doc(db, "users", dummyId));
    const realSnap = await getDoc(doc(db, "users", realId));

    if (!dummySnap.exists() || !realSnap.exists()) throw new Error("Pelajar tidak dijumpai");

    const dummy = dummySnap.data();
    const real = realSnap.data();

    const mergedProgress = [...(real.progress || []), ...(dummy.progress || [])];

    await updateDoc(doc(db, "users", realId), {
        progress: mergedProgress,
        // optional: merge avatar or other fields here
    });

    await deleteDoc(doc(db, "users", dummyId));
};

export const saveStudentProgress = async (studentId, progress) => {
    try {
        const studentRef = doc(db, "students", studentId);
        const studentSnap = await getDoc(studentRef);

        if (studentSnap.exists()) {
            const existingProgress = studentSnap.data().progress || [];
            const updatedProgress = [...existingProgress, progress];

            await updateDoc(studentRef, {
                progress: updatedProgress, // Append new progress to the history
            });
        } else {
            await setDoc(studentRef, {
                progress: [progress], // Create a new progress array if none exists
            });
        }

    } catch (error) {
        console.error("Error saving student progress:", error);
        throw new Error("Failed to save student progress.");
    }
};


// Add a new school
export const addSchool = async (schoolName, adminId) => {
    try {
        const schoolRef = collection(db, "schools");
        const newSchool = await addDoc(schoolRef, {
            name: schoolName,
            admin: adminId, // Assign admin
            teachers: [adminId], // Admin is the first teacher by default
            createdBy: adminId, // Keep track of creator
        });
        return { id: newSchool.id, name: schoolName };
    } catch (err) {
        console.error("Error adding school:", err);
        throw err;
    }
};

// Get all schools
export const getSchools = async () => {
    try {
        const schoolsRef = collection(db, "schools");
        const querySnapshot = await getDocs(schoolsRef);
        return querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    } catch (err) {
        console.error("Error fetching schools:", err);
        throw err;
    }
};





export const getApprovedSchools = async () => {
    const q = query(collection(db, "schools"), where("approved", "==", true));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const addTeacherToSchool = async (teacherId, teacherName, email, schoolIds) => {
    try {
        const teacherRef = doc(db, "teachers", teacherId); // guna id dari localStorage
        const schoolDetails = schoolIds.map((schoolId) => ({
            schoolId,
            isAdmin: false, // Default to false; can be updated later
        }));

        await setDoc(teacherRef, {
            name: teacherName,
            email,
            role: "teacher",
            isApproved: false,
            schools: schoolDetails, // Store school details including `isAdmin`
        });
    } catch (err) {
        console.error("Error adding teacher:", err);
        throw err;
    }
};


export const fetchSchools = async () => {
    try {
        const schoolsRef = collection(db, "schools");
        const querySnapshot = await getDocs(schoolsRef);
        const schools = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));
        return schools;
    } catch (err) {
        console.error("Error fetching schools:", err);
        throw err;
    }
};





// Remove a teacher from a school
export const removeTeacherFromSchool = async (teacherId, schoolId) => {
    try {
        const schoolRef = doc(db, "schools", schoolId);
        await updateDoc(schoolRef, {
            teachers: arrayRemove(teacherId),
        });
    } catch (err) {
        console.error("Error removing teacher from school:", err);
        throw err;
    }
};

export const getTeachersForSchool = async (schoolId) => {
    try {
        const teacherRef = collection(db, "teachers");
        const querySnapshot = await getDocs(teacherRef);

        const teachers = querySnapshot.docs
            .map((doc) => ({ id: doc.id, ...doc.data() }))
            .filter((teacher) =>
                teacher.schools.some(
                    (school) => school.schoolId === schoolId && school.isApproved
                )
            );

        return teachers;
    } catch (err) {
        console.error("Error fetching teachers for school:", err);
        throw err;
    }
};



export const addClassroom = async (classroomName, schoolId, teacherId) => {
    try {
        const sanitizedClassroomName = generateClassroomId(classroomName);
        const classroomId = sanitizedClassroomName;

        // Simpan dalam subkoleksi schools/{schoolId}/classrooms/{classroomId}
        const classroomRef = doc(db, "schools", schoolId, "classrooms", classroomId);

        // Check if the classroom already exists
        const classroomSnap = await getDoc(classroomRef);
        if (classroomSnap.exists()) {
            throw new Error(`Classroom "${classroomName}" already exists in school "${schoolId}".`);
        }

        // Add the classroom to Firestore
        await setDoc(classroomRef, {
            id: classroomId,
            name: classroomName,
            schoolId,
            teacherId,
            students: [],
            createdAt: Timestamp.now(),
            teachers: [teacherId],

        });

        return { id: classroomId, name: classroomName };
    } catch (error) {
        console.error("Error adding classroom:", error);
        throw error;
    }
};

export const getClassroomsForSchool = async (schoolId) => {

    const classroomsRef = collection(db, "schools", schoolId, "classrooms");
    const classroomsSnapshot = await getDocs(classroomsRef);
    const classrooms = [];

    for (const classroom of classroomsSnapshot.docs) {
        const classroomData = classroom.data();

        let teacherName = "Unknown";
        let teacherAvatar = null;

        if (classroomData.teacherId) {
            const teacherQuery = query(
                collection(db, "teachers"),
                where("id", "==", classroomData.teacherId)
            );
            const teacherSnapshot = await getDocs(teacherQuery);

            if (!teacherSnapshot.empty) {
                const teacherDoc = teacherSnapshot.docs[0].data();
                teacherName = teacherDoc.name;
                teacherAvatar = teacherDoc.avatar || null;
            }
        }

        classrooms.push({
            id: classroom.id,
            ...classroomData,
            teacherName,
            teacherAvatar,
        });

    }

    return classrooms;
};






export const getApprovedStudentsForClassroom = async (classroomId) => {
    try {
        const studentsRef = collection(db, "students");


        const querySnapshot = await getDocs(studentsRef);

        const approvedStudents = querySnapshot.docs
            .map((doc) => doc.data())
            .filter((student) =>
                student.classroomApprovals.some(
                    (approval) => approval.classroomId === classroomId && approval.isApproved
                )
            );

        return approvedStudents;
    } catch (err) {
        console.error("Error fetching approved students for classroom:", err);
        throw err;
    }
};


export const getTeacherByClassroom = async (teacherId) => {
    try {
        const teachersRef = collection(db, "teachers");
        const q = query(teachersRef, where("id", "==", teacherId));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
            const teacherData = querySnapshot.docs[0].data(); // Get the first matched document
            return teacherData;
        } else {
            console.error("No teacher found with the given teacherId.");
            return null;
        }
    } catch (error) {
        console.error("Error fetching teacher:", error);
        throw error;
    }
};





// Remove a student from a classroom
export const removeStudentFromClassroom = async (studentId, classroomId) => {
    try {
        const classroomRef = doc(db, "classrooms", classroomId);
        await updateDoc(classroomRef, {
            students: arrayRemove(studentId),
        });
    } catch (err) {
        console.error("Error removing student from classroom:", err);
        throw err;
    }
};

export const getStudentsForClassroom = async (classroomId) => {
    try {
        const studentsRef = collection(db, "students");
        const querySnapshot = await getDocs(studentsRef);

        const approvedStudents = querySnapshot.docs
            .map((doc) => ({ id: doc.id, ...doc.data() })) // Include all fields
            .filter((student) =>
                (student.classroomApprovals || []).some(
                    (approval) => approval.classroomId === classroomId && approval.isApproved
                )
            );

        return approvedStudents;
    } catch (error) {
        console.error("Error fetching approved students for classroom:", error);
        throw error;
    }
};



export const approveStudent = async (studentId, classroomId, schoolId) => {
    try {
        const userRef = doc(db, "users", studentId);
        const userSnap = await getDoc(userRef);

        if (!userSnap.exists()) {
            throw new Error(`Student with ID "${studentId}" not found in users collection.`);
        }

        const userData = userSnap.data();

        const studentRef = doc(db, "students", studentId);
        await setDoc(studentRef, {
            id: studentId,
            name: userData.name,
            email: userData.email,
            avatar: userData.avatar || null,
            progress: [],
            classroomApprovals: [{ classroomId, isApproved: true }],
            schoolId,
            createdAt: userData.createdAt || Timestamp.now(),
        });

        const classroomRef = doc(db, "schools", schoolId, "classrooms", classroomId);
        await updateDoc(classroomRef, {
            students: arrayUnion(studentId),
            pendingStudents: arrayRemove(studentId),
        });

        // 🔄 Trim dokumen user selepas migrasi
        await setDoc(userRef, {
            email: userData.email,
            password: userData.password,
            role: userData.role,
            isApproved: true,
        });

    } catch (error) {
        console.error("❌ Error approving student:", error);
        throw error;
    }
};




export const assignAdminToSchool = async (teacherId, schoolId) => {
    try {
        const teacherRef = doc(db, "teachers", teacherId);
        const teacherSnap = await getDoc(teacherRef);

        if (!teacherSnap.exists()) {
            throw new Error(`Teacher with ID "${teacherId}" not found.`);
        }

        const teacherData = teacherSnap.data();

        // Ensure the teacher is associated with the school
        const updatedSchools = teacherData.schools.map((school) =>
            school.schoolId === schoolId
                ? { ...school, isAdmin: true } // Update the `isAdmin` flag
                : school
        );

        await updateDoc(teacherRef, {
            schools: updatedSchools,
        });

    } catch (error) {
        console.error("Error assigning admin role:", error);
        throw error;
    }
};

export const getPendingTeachersFromUsers = async (schoolId) => {
    try {
        const usersRef = collection(db, "users");
        const snapshot = await getDocs(query(usersRef, where("role", "==", "teacher")));

        const pendingTeachers = snapshot.docs
            .map((doc) => ({ id: doc.id, ...doc.data() }))
            .filter((user) =>
                !user.approved &&
                (user.schools || []).some((s) => s.schoolId === schoolId)
            );

        return pendingTeachers;
    } catch (error) {
        console.error("Error fetching pending teachers from users:", error);
        throw error;
    }
};



export const getPendingStudents = async (classroomId, schoolId) => {
    try {
        const classroomRef = doc(db, "schools", schoolId, "classrooms", classroomId);
        const classroomSnap = await getDoc(classroomRef);
        const classroomData = classroomSnap.data();

        const pendingIds = classroomData?.pendingStudents || [];

        if (pendingIds.length === 0) return [];

        const usersRef = collection(db, "users");

        // Batched query (max 10 IDs at once due to Firestore limitation)
        const batches = [];
        while (pendingIds.length) {
            const batch = pendingIds.splice(0, 10);
            batches.push(
                getDocs(query(usersRef, where("id", "in", batch)))
            );
        }

        const results = (await Promise.all(batches)).flatMap(snapshot =>
            snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
        );

        return results;
    } catch (error) {
        console.error("Error fetching pending students:", error);
        throw error;
    }
};



export const approveTeacherAndMigrate = async (teacherId, schoolId) => {
    const userRef = doc(db, "users", teacherId);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
        throw new Error(`User with ID "${teacherId}" not found.`);
    }

    const userData = userSnap.data();

    if (userData.role !== "teacher") {
        throw new Error("User is not a teacher.");
    }

    const schools = userData.schools || [];
    const updatedSchools = schools.map((school) =>
        school.schoolId === schoolId
            ? { ...school, isApproved: true } // ✅ hanya set isApproved
            : school
    );

    const teacherData = {
        id: teacherId,
        name: userData.name,
        email: userData.email,
        avatar: userData.avatar || null,
        createdAt: userData.createdAt || Timestamp.now(),
        role: "teacher",
        schools: updatedSchools,
    };

    await setDoc(doc(db, "teachers", teacherId), teacherData);

    // Trim user doc
    await setDoc(userRef, {
        email: userData.email,
        password: userData.password,
        role: userData.role,
        approved: true,
    });

};







